import {
   DELETED_USERS,
  DELETED_USERS_SUCCESS,
  DELETED_USERS_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  deletedUsers: [],
};

const deletedusersReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case DELETED_USERS:
      return { ...state, loading: true };
    case DELETED_USERS_SUCCESS:
      return {
        ...state,
        deletedUsers: action?.payload,
        loading: false,
      };
    case DELETED_USERS_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default deletedusersReducer;
